import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-instagram",
  imports: [],
  templateUrl: "./icon-instagram.component.html",
  styleUrl: "./icon-instagram.component.scss",
})
export class IconInstagramComponent {
  @Input() color = "#fff";
}
